import { Grid } from "@material-ui/core";
import styled, { css } from "styled-components";
import theme from "~/styles/theme";
import { Button } from "~/components/elements";

export const FormHolder = styled.div`
  padding: 0 16px;
  margin: 0 auto;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0;
    max-width: 496px;
  }

  h2 {
    color: ${theme.palette.neutral.primary.key};

    strong {
      font-weight: 700;
    }
  }

  p {
    color: ${theme.palette.brand.primary.dark};
    span {
      cursor: pointer;
      font-family: ${theme.typography.secondaryFont};
      text-decoration: underline;
    }
    strong {
      font-family: ${theme.typography.secondaryFont};
    }
  }
`;

export const GridHolder = styled.div`
  margin: -8px;
`;

export const FormLimiter = styled.form`
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    margin: 0 auto;
  }
`;

export const TermsHolder = styled.div`
  background: ${theme.palette.neutral.primary.light};
  position: relative;
  padding: 32px 26px 27px 24px;
  border-radius: 32px;
  label {
    display: flex;
    > div {
      width: 150%;
      margin-left: 26px;
    }
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 40px 24px 40px 40px;
  }

  h6 {
    color: ${theme.palette.neutral.primary.key};
  }

  p {
    display: inline-block;
    vertical-align: top;
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    a {
      color: ${theme.palette.neutral.primary.key};
      font-family: ${theme.typography.fontFamily};
    }

    strong {
      color: ${theme.palette.neutral.primary.key};
      font-family: ${theme.typography.fontFamily};
    }

    span {
      border: 1px solid ${theme.palette.brand.primary.dark};
    }
  }
`;

export const ButtonsGrid = styled(Grid)`
  width: 100%;
  div,
  button {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    button {
      width: 100%;
    }
  }
`;
export const CaptchaHolder = styled.div`
  > div > div > div {
    margin: 0 auto;
  }
`;

export const PasswordRules = styled.div`
  text-align: left;
  padding: 48px;
  border-radius: 8px;
  border: 1px solid ${theme.palette.brand.primary.medium};
  background: ${theme.palette.neutral.primary.light};
  margin-bottom: 24px;

  p {
    font-size: 18px;
    color: ${theme.palette.brand.primary.dark};
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  ul {
    li {
      font-size: 12px;
      letter-spacing: 0;
      line-height: 16px;
      font-weight: 400;
      padding: 4px 0;
      flex-direction: row;
      display: flex;
      align-items: center;

      svg {
        width: 12px;
        height: 12px;
        margin-right: 12px;
      }

      &.error {
        color: ${theme.palette.feedback.error.key};
      }
    }
  }
`;

export const InfoContactSubtitle = styled.div`
  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
  }
`;

export const PhoneTitle = styled.div`
  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
  }
`;

export const Disclaimer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: start;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    font-size: 14px;
    font-weight: 500;
  }

  svg {
    margin-top: 5px;

    path {
      fill: #026d58;
    }
  }
`;

export const IconMargin = styled.span`
  margin-right: 8px;
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const FindCepLink = styled.a`
  p {
    color: ${theme.palette.neutral.primary.key};
    font-weight: 500;
    font-size: 14px;
  }
`;

export const FindCep = styled(Button)`
  width: 100%;
`;

export const LabelRadio = styled.div`
  display: flex;
  span {
    ${(props) =>
      props.error &&
      css`
        margin-top: 0;
      `}
  }

  p {
    ${(props) =>
      props.error &&
      css`
        color: ${theme.palette.feedback.error.key} !important;
      `}
    a {
      ${(props) =>
        props.error &&
        css`
          color: ${theme.palette.feedback.error.key} !important;
        `}
    }
  }
`;
